import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from 'src/app/modules/shared.module';
import { ContactSalesComponent } from './contact-sales.component';

@NgModule({
  declarations: [
    ContactSalesComponent,
  ],
  imports: [
    SharedModule,
    FlexLayoutModule,
    MatButtonModule,
  ],
  exports: [
    ContactSalesComponent,
  ],
})
export class ContactSalesModule { }
